export const AFFORTABLE_SHIPMENT_SIZES: string[] = [
    "2A0",
    "B0",
    "A0",
    "B1 or A1",
    "B2 or A2",
    "A3, B3, A4 or B4"
]